module.exports = __webpack_public_path__ + "static/media/Wheelchair Racer.79617cc3.jpg";